import React, { Component } from "react";
import "./Prompts.css";

type ElectionTrackerAlertProps = {
  /** Where the token ends up: 1 or 2 failed governments, or 3 when the top policy gets enacted. */
  trackerPosition: number;
  closeAlert: () => void;
};

type ElectionTrackerAlertState = {
  /** Where the token is drawn. It starts one step back and slides to its new place. */
  shown: number;
};

const STOPS = ["Start", "1 failed", "2 failed", "Chaos"];

class ElectionTrackerAlert extends Component<ElectionTrackerAlertProps, ElectionTrackerAlertState> {
  moveTimeout: NodeJS.Timeout | undefined;

  constructor(props: ElectionTrackerAlertProps) {
    super(props);
    this.state = {
      shown: Math.max(0, props.trackerPosition - 1),
    };
  }

  componentDidMount() {
    // Slide the token to its new place shortly after the alert appears.
    this.moveTimeout = setTimeout(() => this.setState({ shown: this.props.trackerPosition }), 500);
  }

  componentWillUnmount() {
    clearTimeout(this.moveTimeout);
  }

  render() {
    const position = this.props.trackerPosition;
    const shown = this.state.shown;
    const chaos = position >= 3;
    const percent = (n: number) => (n / 3) * 100 + "%";
    return (
      <div className="pp">
        <div className="pp-kicker">Election tracker</div>
        <div className="pp-title">{chaos ? "Chaos: the country is ungoverned" : "The government failed"}</div>
        <div className="pp-text">
          <strong>{position} of 3</strong> failed governments in a row.
        </div>

        <div className="pp-tracker">
          <div
            className="et"
            role="img"
            aria-label={"The election tracker is at " + STOPS[position] + ": " + position + " of 3 failed governments in a row."}
          >
            <div className="et-rail">
              <div className={"et-fill" + (shown >= 2 ? " et-fill-danger" : "")} style={{ width: percent(shown) }} />
            </div>
            {STOPS.map((label, n) => (
              <div
                key={label}
                className={
                  "et-stop" + (n <= shown ? " et-stop-on" : "") + (n === 3 ? " et-stop-chaos" : "")
                }
                style={{ left: percent(n) }}
              >
                <span className="et-node" />
                <span className="et-label">{label}</span>
              </div>
            ))}
            <div className={"et-token" + (shown >= 2 ? " et-token-danger" : "")} style={{ left: percent(shown) }} />
          </div>
        </div>

        <div className={"pp-note" + (chaos || position === 2 ? " pp-note-danger" : "")}>
          {chaos
            ? "The top policy of the draw pile is enacted now. No presidential power is used, and everyone is eligible again."
            : position === 2
            ? "One more failed government and the top policy of the draw pile is enacted."
            : "Three failed governments in a row enact the top policy. The tracker resets when a policy is passed."}
        </div>

        <div className="pp-actions">
          <button id="prompt-button" className="gold-button pp-btn" onClick={this.props.closeAlert}>
            <span className="gold-label">OKAY</span>
          </button>
        </div>
      </div>
    );
  }
}

export default ElectionTrackerAlert;
